import React, { useContext, useEffect, useState } from 'react';
import './AppealList.scss';
import { Typography, Pagination, Select } from 'antd';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import TabNotificationCollapse from '../TabNotificationCollapse/TabNotificationCollapse';
import { Appeal } from '../../model/Appeal';
import { AppealProvider } from '../../context/appeal/AppealContext';
import { Context } from '../../index';
import { Input } from 'antd';
import { Status } from '../../model/Status';

interface AppealListProps {
  onlyUser: boolean;
}

interface AppealListFilter {
  appealNumber?: string;
  appealStatus?: string;
}

const AppealList = (props: AppealListProps): JSX.Element => {
  const pageSize = 10;
  const { store } = useContext(Context);
  const [currentPage, setCurrentPage] = useState(1);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(pageSize);
  const [appeals, setAppeals] = useState<Appeal[]>([]);
  const [filteredAppeals, setFilteredAppeals] = useState<Appeal[]>([]);
  const [filter, setFilter] = useState<AppealListFilter | null>(null);
  const [statuses, setStatuses] = useState<Status[]>([]);

  useEffect(() => {
    if (props.onlyUser) {
      const userId = store.getUserId();
      store.getAppealsList(userId).then((resp) => {
        if (resp) {
          setAppeals(resp);
          setFilteredAppeals(resp);
        }
      });
    } else {
      store.getAppealsListByRole().then((resp) => {
        if (resp) {
          setAppeals(resp);
          setFilteredAppeals(resp);
        }
      });
    }
    store.getAppealStatuses(props.onlyUser).then((resp) => {
      if (resp) {
        setStatuses(resp);
      }
    });
  }, []);

  const handleAppealRemove = (appealId: number): void => {
    const newAppealsState = appeals.filter((el) => el.id !== appealId);
    setAppeals(newAppealsState);
    setFilteredAppeals(newAppealsState);
  };

  const paginationHandle = (page: number) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * pageSize);
    setMaxIndex(page * pageSize);
  };

  const handleFilterAppeal = () => {
    const appealFilter = appeals.filter((appeal) => {
      let filterQuery = false;
      if (filter?.appealNumber) {
        filterQuery = appeal.id === +filter?.appealNumber;
      } else if (filter?.appealStatus) {
        if (props.onlyUser) {
          filterQuery = appeal.statusUser.code === filter?.appealStatus;
        } else {
          filterQuery = appeal.status.code === filter?.appealStatus;
        }
      } else {
        filterQuery = true;
      }
      return filterQuery;
    });
    setFilteredAppeals(appealFilter);
    paginationHandle(1);
  };

  const handleFilterClear = () => {
    setFilter(null);
    setFilteredAppeals(appeals);
    paginationHandle(1);
  };

  return (
    <>
      <div className="myMessages__filter">
        <div className="Filter-container">
          <div className="Number-filter">
            <label>По номеру</label>
            <Input
              name="appealNumber"
              placeholder="Введите номер обращения"
              value={filter?.appealNumber}
              onChange={(event) =>
                setFilter({
                  appealNumber: event.target.value,
                  appealStatus: filter?.appealStatus,
                })
              }
            />
          </div>
          <div className="Status-filter">
            <label>По состоянию</label>
            <Select
              placeholder="Выберите из списка"
              optionLabelProp="label"
              value={filter?.appealStatus || undefined}
              onChange={(value) =>
                setFilter({
                  appealStatus: value as string,
                  appealNumber: filter?.appealNumber,
                })
              }
            >
              {statuses.map((item: Status, index: number) => {
                return (
                  <Select.Option
                    key={index}
                    label={item.name}
                    value={item.code}
                  >
                    <span>{item.name}</span>
                  </Select.Option>
                );
              })}
            </Select>
          </div>
        </div>
        <div className="Button-container">
          <button onClick={handleFilterAppeal}>Искать</button>
          <button onClick={handleFilterClear}>Сбросить</button>
        </div>
      </div>

      {!filteredAppeals.length ? (
        <LoaderSpinner />
      ) : (
        <div className="myMessages">
          <div className="myMessages__titles">
            <Typography.Text className="myMessages__titles__id">
              №
            </Typography.Text>
            <Typography.Text className="myMessages__titles__message-title">
              <div>Сообщения гражданина</div>
              <div>Сообщения</div>
            </Typography.Text>
            <Typography.Text className="myMessages__titles__status">
              <div>Состояние сообщения</div>
              <div>Состояние</div>
            </Typography.Text>
            <Typography.Text className="myMessages__titles__date">
              <div>Сообщение создано</div>
            </Typography.Text>
          </div>
          {filteredAppeals.map(
            (item, index) =>
              index >= minIndex &&
              index < maxIndex && (
                <AppealProvider key={item.id}>
                  <TabNotificationCollapse
                    key={item.id}
                    appeal={item}
                    onlyUserStatus={props.onlyUser}
                    handleAppealRemove={handleAppealRemove}
                  />
                </AppealProvider>
              )
          )}
          {filteredAppeals.length > pageSize && (
            <div className="myMessages__pagination">
              <Pagination
                pageSize={pageSize}
                current={currentPage}
                total={filteredAppeals.length}
                onChange={paginationHandle}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AppealList;
